import React, { Component } from 'react';
import _ from 'lodash';
import UrlParse from 'url-parse';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import GeneralHelper from '../../../../helpers/general';
import OptionHelper from '../../../../helpers/Option';
import { Button, Card, Col, Form, Input, Row, Select, InputNumber, Modal } from 'antd';

export class EquipmentBasicForm extends Component {
	formRef = React.createRef();
	state = {
		name: '',
		slug: '',
		description: '',
		location_id: '',
		status: '',
		type: '',
		duration: '',
		channel: '',
		port: '',
		controller_ip: '',
		loading: false,
		disableBtn: true,
		showDeleteModal: false
	};

	componentDidMount() {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { equipment } = this.props.pageProps;
		this.props.getLocations({ details: true });

		if (query.id && equipment) {
			this.initData();
		}
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.pageProps;
		const { meta } = this.props.pageProps;
		if (meta && meta !== prevMeta) {
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};

			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	initData = () => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { equipment } = this.props.pageProps;
		if (query.id && equipment) {
			const {
				name,
				slug,
				description,
				location_id,
				status,
				type,
				duration,
				channel,
				port,
				controller_ip
			} = equipment;

			this.setState({
				name,
				slug,
				description,
				location_id,
				status,
				type,
				duration,
				channel,
				port,
				controller_ip
			});
		}
	};

	onFieldChange = (data) => {
		if(['name', 'description'].includes(data.name)) {
			this.formRef.current.setFieldsValue({[data.name]: GeneralHelper.toNormalCase(data.value)});
		}
		if(data.name === 'slug') {
			this.formRef.current.setFieldsValue({[data.name]: data.value.replaceAll(' ', '-').toLowerCase().replace(/[^a-z0-9-]/g, '')});
		}
		if(data.name === 'controller_ip') {
			this.formRef.current.setFieldsValue({[data.name]: data.value.replace(/[^0-9.]/g, '')});
		}
		if(data.name === 'type' && data.value === 'online_booking_equipment') {
			this.formRef.current.setFieldsValue({ duration: '' });
			this.setState({ ...this.state, type: data.value, duration: '' }, () => this.checkValues());
			return;
		}
		this.setState({ ...this.state, [data.name]: data.value }, () => this.checkValues());
	};

	checkValues = () => {
		const { equipment } = this.props.pageProps;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		let isValueEqual = false;
		// enable/disable submit button if fields are empty or not empty
		if (query.id) {
			// disable submit button if values are same with prev/default values
			const keys = [
				'name',
				'slug',
				'description',
				'location_id',
				'status',
				'type',
				'duration',
				'channel',
				'port',
				'controller_ip'
			];
			const newPropArrObj = GeneralHelper.checkIfSameValues(keys, equipment);
			const newStateArrObj = GeneralHelper.checkIfSameValues(keys, this.state);
			isValueEqual = _.isEqual(newStateArrObj, newPropArrObj);
		}
		const {
			name,
			location_id,
			status,
			type,
			duration,
			channel,
			port,
			controller_ip
		} = this.state;

		if(type === 'online_booking_equipment') {
			name && location_id && status && type && channel && port && controller_ip !== '' && !isValueEqual ? this.setState({ disableBtn: false }) : this.setState({ disableBtn: true });
		} else {
			name && location_id && status && type && duration && channel && port && controller_ip !== '' && !isValueEqual ? this.setState({ disableBtn: false }) : this.setState({ disableBtn: true });
		}
	};

	onSubmit = async () => {
		this.setState({ loading: true });
		const { disableBtn } = this.state;
		if (!disableBtn) {
			const tempState = { ...this.state };
			// show red error borders of input
			const tempErrorObj = {
				name: tempState.name.match(/Invalid/g) ? true : false,
				// slug: tempState.slug.match(/Invalid/g) ? true : false, // Slug is not required
				// description: tempState.description.match(/Invalid/g) ? true : false, // Description is not required
				location_id: tempState.location_id.match(/Invalid/g) ? true : false,
				status: tempState.status.match(/Invalid/g) ? true : false,
				type: tempState.type.match(/Invalid/g) ? true : false,
				...(tempState.type === 'non_booking_equipment' && { duration: tempState.duration.toString().match(/Invalid/g) ? true : false }),
				channel: tempState.channel.toString().match(/Invalid/g) ? true : false,
				port: tempState.port.toString().match(/Invalid/g) ? true : false,
				controller_ip: tempState.controller_ip.match(/Invalid/g) ? true : false
			};
			if (Object.values(tempErrorObj).includes(true)) {
				this.setState({ disableBtn: true });
			} else {
				await this.props.onSubmit(this.state);
				this.setState({ disableBtn: true });
			}
			this.setState({ errors: tempErrorObj });
		}

		this.setState({ loading: false });
	};

	onDelete = async () => {
		this.props.deleteEquipmentById();
		this.setState({showDeleteModal: false});
	}

	render() {
		const {
			name,
			slug,
			description,
			location_id,
			status,
			type,
			duration,
			channel,
			port,
			controller_ip,
			loading,
			disableBtn,
			showDeleteModal
		} = this.state;
		const { equipment, loadingSubmit } = this.props.pageProps;
		const { locations } = this.props.locationsListPageProps;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);

		return (
			<Card style={{ margin: '15px 15px 0', border: 0 }}>
				<Form
					ref={this.formRef}
					layout="vertical"
					initialValues={{
						name: !_.isEmpty(equipment) ? equipment.name : name && name,
						slug: !_.isEmpty(equipment) ? equipment.slug : slug && slug,
						description: !_.isEmpty(equipment) ? equipment.description : description && description,
						location_id: !_.isEmpty(equipment) ? equipment.location_id : location_id && location_id,
						status: !_.isEmpty(equipment) ? equipment.status : status && status,
						type: !_.isEmpty(equipment) ? equipment.type : type && type,
						duration: !_.isEmpty(equipment) ? equipment.duration : duration && duration,
						channel: !_.isEmpty(equipment) ? equipment.channel : channel && channel,
						port: !_.isEmpty(equipment) ? equipment.port : port && port,
						controller_ip: !_.isEmpty(equipment) ? equipment.controller_ip : controller_ip && controller_ip
					}}
				>
					<Row
						type="flex"
						justify="center"
						align="middle"
					>
						<Col
							xl={7}
							lg={18}
							md={18}
							sm={24}
							xs={24}
						>
							<Form.Item
								label="Equipment Name"
								name="name"
								rules={[
									{ required: true, message: 'Please enter a name.' }
								]}
							>
								<Input
									onChange={val => {
										const data = {
											name: 'name',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									maxLength={80}
								/>
							</Form.Item>
							<Form.Item
								label="Equipment Identifier"
								name="slug"
							>
								<Input
									onChange={val => {
										const data = {
											name: 'slug',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									maxLength={80}
								/>
							</Form.Item>
							<Form.Item
								label="Equipment Description"
								name="description"
							>
								<Input.TextArea
									onChange={val => {
										const data = {
											name: 'description',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									rows={4}
								/>
							</Form.Item>
							<Form.Item
								label="Location"
								name="location_id"
								rules={[
									{ required: true, message: 'Please select a location.' }
								]}
							>
								<Select
									placeholder="Location"
									optionFilterProp="children"
									onChange={val => {
										const data = {
											name: 'location_id',
											value: val
										};
										this.onFieldChange(data);
									}}
									style={{ width: '100%' }}
								>
									{locations.map((option, index) => (
										<Select.Option
											key={index}
											value={option._id}
										>{option.name}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item
								label="Status"
								name="status"
								rules={[
									{ required: true, message: 'Please select a status.' }
								]}
							>
								<Select
									placeholder="Status"
									optionFilterProp="children"
									onChange={val => {
										const data = {
											name: 'status',
											value: val
										};
										this.onFieldChange(data);
									}}
									style={{ width: '100%' }}
								>
									{OptionHelper.equipmentStatus().map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item
								label="Equipment Type"
								name="type"
								rules={[
									{ required: true, message: 'Please select a equipment type.' }
								]}
							>
								<Select
									placeholder="Equipment Type"
									optionFilterProp="children"
									onChange={val => {
										const data = {
											name: 'type',
											value: val
										};
										this.onFieldChange(data);
									}}
									style={{ width: '100%' }}
								>
									{OptionHelper.equipmentTypeOptions().map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
							</Form.Item>
							{
								type === 'non_booking_equipment' && (
									<Form.Item
										label="Duration (minutes)"
										name="duration"
										rules={[
											{ required: true, message: 'Please enter a duration.' }
										]}
									>
										<InputNumber
											type="number"
											onChange={val => {
												const data = {
													name: 'duration',
													value: val
												};
												this.onFieldChange(data);
											}}
											onKeyDown={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
											style={{ width: '100%' }}
											min={1}
										/>
									</Form.Item>
								)
							}

							<Form.Item
								label="Relay Box Channel"
								name="channel"
								rules={[
									{ required: true, message: 'Please select a box channel.' }
								]}
							>
								<Select
									placeholder="Relay Box Channel"
									optionFilterProp="children"
									onChange={val => {
										const data = {
											name: 'channel',
											value: val
										};
										this.onFieldChange(data);
									}}
									style={{ width: '100%' }}
								>
									{
										(() => {
											const options = [];
											for(let i=1; i<=8; i++) {
												options.push(
													<Select.Option
														key={i}
														value={i}
													>{i}</Select.Option>);
											}
											return options;
										})()
									}
								</Select>
							</Form.Item>
							<Form.Item
								label="Equipment Controller Port Number"
								name="port"
								rules={[
									{ required: true, message: 'Please enter a port number.' }
								]}
							>
								<InputNumber
									type="number"
									onChange={val => {
										const data = {
											name: 'port',
											value: val
										};
										this.onFieldChange(data);
									}}
									onKeyDown={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
									style={{ width: '100%' }}
									min={0}
								/>
							</Form.Item>
							<Form.Item
								label="Equipment Controller IP"
								name="controller_ip"
								rules={[
									{ required: true, message: 'Please enter a IP number.' }
								]}
							>
								<Input
									onChange={val => {
										const data = {
											name: 'controller_ip',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									maxLength={15}
								/>
							</Form.Item>
							<Row
								type="flex"
								justify={query.id ? 'space-between' : 'end'}
							>
								{query.id && (
									<Button
										onClick={() => {
											this.setState({showDeleteModal: true});
										}}
										style={{ ...equipment && equipment.status === 'disabled' && {background: 'rgb(226, 0, 0)', color: '#fff'} }}
										disabled={ equipment && equipment.status === 'enabled' }
									>Delete</Button>
								)}
								<Form.Item>
									<Button
										onClick={this.onSubmit}
										style={{ background: '#003366', color: '#fff' }}
										disabled={ loading || disableBtn }
										loading={ loadingSubmit }
									>{!query.id ? 'Create' : 'Save'}</Button>
								</Form.Item>
							</Row>
						</Col>
					</Row>
				</Form>
				{
					showDeleteModal && (
						<Modal
							title={`Delete Equipment: ${GeneralHelper.truncateString(name, 75)}`}
							centered
							visible={showDeleteModal}
							onOk={() => this.onDelete()}
							onCancel={() => this.setState({ showDeleteModal: false })}
						>
							Are you sure you want to delete?
						</Modal>
					)
				}
			</Card>
		);
	}
}

export default compose(
	withAlert()
)(EquipmentBasicForm);
